/* eslint-disable prefer-template */
import React from "react";
import { Pane, CircleMarker, Tooltip } from "react-leaflet";
import PropTypes from "prop-types";
import COLORS from "../../utils/constants";
import MapTooltip from "./MapTooltip";

const Icons = ({ iconData, year, tooltipSchema, iconScale }) => {
  const yearClean = year.toString().slice(-2);
  const regexEfrYear = new RegExp("^efr-0?" + yearClean + "$", "gi");
  const radiusAccessor = Object.keys(iconData[0].properties).find((x) =>
    regexEfrYear.test(x)
  );
  return (
    <Pane name="icons" style={{ zIndex: 500 }}>
      {iconData.map((datum) => {
        const { properties, coordinates } = datum;
        const { GEOID } = properties;
        const radius = iconScale(properties[radiusAccessor]);
        return (
          <CircleMarker
            className="leaflet-map-icons__bubble"
            style={{ pointerEvents: "none" }}
            key={`${GEOID}`}
            center={[coordinates[1], coordinates[0]]}
            radius={radius}
            color={COLORS.markers}
            weight={1}
            fillColor={COLORS.markers}
            fillOpacity={1}
          >
            <Tooltip direction="auto" offset={[-8, -2]} opacity={1}>
              <MapTooltip
                key={GEOID}
                properties={properties}
                tooltipSchema={tooltipSchema}
              />
            </Tooltip>
          </CircleMarker>
        );
      })}
    </Pane>
  );
};

Icons.propTypes = {
  year: PropTypes.number.isRequired,
  iconData: PropTypes.arrayOf(PropTypes.object).isRequired,
  tooltipSchema: PropTypes.arrayOf(PropTypes.object).isRequired,
  iconScale: PropTypes.func.isRequired,
};

export default Icons;
